module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0079.jpg?v=5a6647d9";